import { Map } from 'immutable';
import { actionTypes as actionTypes } from '../../../actions/Administration/RfidSettingsPage/automationScenariosViewActions';

let defaultState = {
  loading: false,
  selectedDeviceApp : null,
  deviceAppsOptions : []
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case actionTypes.RFID_SETTINGS_AUTOMATION_SCENARIOS_FETCH_DEVICE_APPS_IN_PROCESS:
      return state.set('loading', true);

    case actionTypes.RFID_SETTINGS_AUTOMATION_SCENARIOS_FETCH_DEVICE_APPS_READY:
      state = state.set('deviceAppsOptions', action.payload);
      return state.set('loading',false);

    case actionTypes.RFID_SETTINGS_AUTOMATION_SCENARIOS_DEVICE_APP_CHANGED:
      return state.set('selectedDeviceApp', action.payload);

    case actionTypes.RFID_SETTINGS_AUTOMATION_SCENARIOS_UNMOUNT:
      return Map(defaultState);

    default:
      return state;
  }
}







